import { AppTourState, AppTourType, SET_TOUR_DATA } from '../types/appTourTypes';

export const initialAppTourState: AppTourState = {
  run: false,
  steps: [],
  startingIndex: 0,
};

export const appTourReducer = (state = initialAppTourState, action: AppTourType): AppTourState => {
  switch (action.type) {
    case SET_TOUR_DATA: {
      return { ...state, run: action.meta.run, steps: action.meta.steps, startingIndex: action.meta.startingIndex };
    }
    default:
      return state;
  }
};
